// Mirrors Boom::Partner::SUBMIT_BOOM_FINANCE_APPS_TRIGGER_* on the API.
// Controls when a partner's BoomFinance (purchase) application is sent to lenders.
export const SUBMIT_BOOM_FINANCE_APPS_TRIGGER_SETTING =
  "submit_boom_finance_apps_trigger";

// Send to lenders automatically once the screening application is approved.
export const SUBMIT_BOOM_FINANCE_ON_APPROVAL = "on_approval";

// Never auto-send; the partner reviews and submits to lenders manually.
// This is the backend default.
export const SUBMIT_BOOM_FINANCE_ON_REVIEW = "on_review";
